<template>
	<div class="divBox" style="text-align: left">
		<el-card class="box-card">
			<el-form inline size="small" @submit.native.prevent>
				<el-form-item label="姓名">
					<el-input placeholder="姓名" v-model="listPram.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input placeholder="手机号" v-model="listPram.phone" clearable></el-input>
				</el-form-item>
				<el-form-item label="服务地址">
					<el-cascader
						v-model="listPram.citys"
						:options="cityList"
						style="width: 100%"
						placeholder="请选择服务地址"
						:props="{ checkStrictly: true }"
						clearable></el-cascader>
				</el-form-item>
				<el-form-item label="来源">
					<el-select v-model="listPram.sourceId" placeholder="请选择来源" clearable filterable>
						<el-option v-for="item in sourceList" :label="item.name" :value="item.id" :key="item.id"></el-option>
					</el-select>
				</el-form-item>

				<!-- <el-form-item>
          <el-select v-model="listPram.createBy" filterable clearable placeholder="请选择销售归属人">
            <el-option v-for="item in saleList" :label="item.realName" :value="item.id" :key="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
				<el-form-item label="录入日期">
					<el-date-picker
						v-model="inputTime"
						type="daterange"
						placeholder="选择录入日期"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						clearable
						value-format="yyyy-MM-dd"
						@change="onchangeTime"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
					<el-button size="mini" type="primary" @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>

			<el-form inline @submit.native.prevent>
				<el-form-item style="width: 100%; text-align: right">
					<el-button size="mini" type="primary" @click="handlerOpenEdit(0)">添加客户</el-button>
				</el-form-item>
			</el-form>

			<el-table id="baseTable" v-loading="listLoading" :height="tableHeight" :data="listData.list" size="mini">
				<el-table-column type="index" label="序号" width="50" align="center" />
				<el-table-column label="姓名" prop="name" min-width="120" align="center" />
				<el-table-column label="手机号" prop="phone" min-width="120" align="center" />
				<el-table-column label="服务地址" prop="areaAddress" min-width="120" />
				<el-table-column label="详细地址" prop="address" min-width="120" />
				<el-table-column label="来源" prop="sourceName" min-width="120" align="center" />
				<el-table-column label="消费次数" prop="consumptionNum" min-width="120" align="center">
					<template slot-scope="scope">
						<el-link type="primary" @click="openConsumptionNum(scope.row)">{{ scope.row.consumptionNum }}</el-link>
					</template>
				</el-table-column>
				<el-table-column label="合同签署次数" prop="contractNum" min-width="120" align="center">
					<template slot-scope="scope">
						<router-link :to="{ path: '/contractManagement/order', query: { phone: scope.row.phone } }">
							<el-link type="primary">{{ scope.row.contractNum }}</el-link>
						</router-link>
					</template>
				</el-table-column>
				<el-table-column label="录入时间" prop="createTime" min-width="120" align="center" />
				<el-table-column label="操作" min-width="130" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" size="mini" @click="handlerOpenDetail(scope.row)">详情</el-button>
						<el-button type="text" size="mini" @click="handlerOpenEdit(1, scope.row)">编辑</el-button>
						<!--            <el-button type="text" size="mini" @click="handlerOpenDel(scope.row)">删除</el-button>-->
					</template>
				</el-table-column>
			</el-table>

			<el-pagination
				:current-page="listPram.page"
				:page-sizes="constants.page.limit"
				:layout="constants.page.layout"
				:total="listData.total"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</el-card>

		<el-dialog
			:visible.sync="editDialogConfig.visible"
			:title="editDialogConfig.isCreate === 0 ? '创建客户' : '编辑客户'"
			destroy-on-close
			:close-on-click-modal="false"
			width="500px">
			<createCustomer
				v-if="editDialogConfig.visible"
				:is-create="editDialogConfig.isCreate"
				:sourceList="sourceList"
				:edit-data="editDialogConfig.editData"
				@hideEditDialog="hideEditDialog" />
		</el-dialog>
		<!-- 详情 -->
		<el-dialog :visible.sync="detailDialog" title="客户详情" destroy-on-close :close-on-click-modal="false" width="50%">
			<el-descriptions border size="small" column="2">
				<el-descriptions-item v-for="(item, ind) in detailData" :label="item.name" :key="ind">
					{{ item.value }}
				</el-descriptions-item>
			</el-descriptions>
			<div style="margin-top: 10px; text-align: end">
				<el-button @click="closeDetail">取消</el-button>
			</div>
		</el-dialog>
		<!-- 消费次数 -->
		<el-dialog
			:visible.sync="consumptionNumDialog"
			title="消费次数详情"
			destroy-on-close
			:close-on-click-modal="false"
			width="50%">
			<consumptionNum v-if="consumptionNumDialog" :consumptionNumData="consumptionNumData" />
		</el-dialog>
	</div>
</template>

<script>
	import createCustomer from './createCustomer.vue';
	import consumptionNum from './consumptionNum.vue';
	// import * as customerApi from '@/api/customer';
	// import { getAdminUserList } from '@/api/clue';
	// import { detail } from '@/api/order';
	import citys from '@/utils/city';
	import tableHeightMixins from '@/mixins/tableHeightMixins';

	export default {
		mixins: [tableHeightMixins],

		data() {
			return {
				listLoading: false,
				inputTime: '',
				sourceList: [
					{ name: '合同订单', id: 1 },
					{ name: '商城订单', id: 2 },
					{ name: '手动录入', id: 3 },
				], //来源
				saleList: [], //归属人
				cityList: citys,
				constants: this.$constants,
				listPram: {
					limit: this.$constants.page.limit[0],
					name: '',
					operatorId: '',
					page: 1,
					shopId: '',
					sourceId: '',
					startTime: '',
					endTime: '',
				},
				listData: {
					list: [
						{
							name: '张三',
							phone: '13800138000',
							areaAddress: '江苏省南京市江宁区',
							address: '东山街道富塘路88号',
							sourceName: '线上推广',
							consumptionNum: 5,
							contractNum: 3,
							createTime: '2026-04-10 10:20:00',
						},
						{
							name: '李四',
							phone: '13900139000',
							areaAddress: '江苏省南京市鼓楼区',
							address: '中山北路100号',
							sourceName: '客户转介绍',
							consumptionNum: 8,
							contractNum: 5,
							createTime: '2026-04-08 14:15:00',
						},
						{
							name: '王五',
							phone: '13700137000',
							areaAddress: '江苏省南京市建邺区',
							address: '河西大街200号',
							sourceName: '线下活动',
							consumptionNum: 2,
							contractNum: 1,
							createTime: '2026-04-12 09:30:00',
						},
						{
							name: '赵六',
							phone: '13600136000',
							areaAddress: '江苏省南京市栖霞区',
							address: '仙林大道66号',
							sourceName: '渠道合作',
							consumptionNum: 0,
							contractNum: 0,
							createTime: '2026-04-16 16:40:00',
						},
						{
							name: '孙七',
							phone: '13500135000',
							areaAddress: '江苏省南京市雨花台区',
							address: '软件大道188号',
							sourceName: '官网注册',
							consumptionNum: 3,
							contractNum: 2,
							createTime: '2026-04-14 11:05:00',
						},
					],
				},
				editDialogConfig: {
					visible: false,
					isCreate: 0, // 0=创建，1=编辑
					editData: {},
				},
				detailDialog: false,
				detailData: [],
				consumptionNumDialog: false,
				consumptionNumData: {},
			};
		},
		components: {
			createCustomer,
			consumptionNum,
		},
		mounted() {
			this.tableList();
			// this.getSourceList();
			// this.getShopAdminList()
		},
		methods: {
			tableList() {
				// this.listLoading = true;
				if (this.listPram.citys) {
					this.listPram.areaCode = this.listPram.citys.join(',');
				}
				// customerApi
				// 	.getCustomerList(this.listPram)
				// 	.then(res => {
				// 		this.listData = res;
				// 	})
				// 	.finally(() => {
				// 		this.listLoading = false;
				// 	});
			},
			// 具体日期
			onchangeTime(e) {
				this.inputTime = e;
				if (!e) {
					this.listPram.startTime = [];
					this.listPram.endTime = [];
				} else {
					this.listPram.startTime = e[0];
					this.listPram.endTime = e[1];
				}
			},
			// 来源列表
			getSourceList() {
				// customerApi.getSource('customer_source').then(res => {
				// 	this.sourceList = res;
				// });
			},
			// 销售归属列表
			getShopAdminList() {
				// getAdminUserList().then(res => {
				// 	this.saleList = res;
				// });
			},
			// 详情
			handlerOpenDetail(res) {
				console.log(res, 'res');
				this.detailData = [
					{ name: 'ID', value: res.id },
					{ name: '姓名', value: res.name },
					{ name: '地址', value: res.areaAddress + res.address },
					{ name: '手机号码', value: res.phone },
					{ name: '来源', value: res.sourceName },
					{ name: '添加时间', value: res.createTime },
					{ name: '消费次数', value: res.consumptionNum },
					{ name: '合同签署次数', value: res.contractNum },
					{ name: '备注', value: res.comment },
				];
				this.detailDialog = true;
			},
			openConsumptionNum(row) {
				this.consumptionNumDialog = true;
				this.consumptionNumData = row;
			},
			closeDetail() {
				this.detailDialog = false;
			},
			handleSearch() {
				this.listPram.page = 1;
				this.tableList();
			},
			resetForm() {
				this.listPram = {
					limit: this.$constants.page.limit[0],
					name: '',
					operatorId: '',
					page: 1,
					shopId: '',
					sourceId: '',
					startTime: '',
					endTime: '',
				};
				this.inputTime = '';
				this.handleSearch();
			},
			handlerOpenEdit(isCreate, editDate) {
				if (editDate) {
					editDate.citys = editDate.areaCode.split(',');
				}
				this.editDialogConfig.editData = editDate;
				this.editDialogConfig.isCreate = isCreate;
				this.editDialogConfig.visible = true;
			},
			hideEditDialog() {
				this.editDialogConfig.visible = false;
				this.tableList();
			},
			handlerOpenDel(rowData) {
				console.log(rowData);
				this.$confirm('确认删除当前数据').then(() => {
					// customerApi.delCustomer(rowData).then(data => {
					// 	this.$message.success('删除数据成功');
					// 	this.tableList();
					// });
				});
			},
			handleSizeChange(val) {
				this.listPram.limit = val;
				this.tableList();
				this.resetScroll();
			},
			handleCurrentChange(val) {
				this.listPram.page = val;
				this.tableList();
				this.resetScroll();
			},
			clear() {
				this.tableList();
			},
		},
	};
</script>

<style></style>
